module.exports = __webpack_public_path__ + "static/consensus_protocol-9e1ec9f1c51eae734f503d02725f1965.png";